import {
  useQuery,
  UseQueryResult,
} from '@tanstack/react-query';
import {
  PrefetchedDataProps,
} from 'pages/Dashboard/types/common';

export default function usePrefetchedData<T>({
  key,
  fetchFn,
  enabled,
  retry,
  retryDelay,
}: PrefetchedDataProps<T>): UseQueryResult<T, Error> {
  return useQuery<T, Error>({
    queryKey: key,
    queryFn: fetchFn,
    gcTime: Infinity,
    enabled,
    retry,
    retryDelay,
  });
}
